import React from "react";

import {
  Box,
  Typography,
  IconButton,
  Link,
  Breadcrumbs,
  Stack,
  Tooltip,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Excel from "../../img/excel.png";
import { useNavigate } from "react-router-dom";
import "./TopView.css";
import CustomButton from "./Button";

const TopViewNav = ({
  topViewNavData,
  statusBtn,
  clientSatatusBtn,
  ApproveHandler,
  openDyanamiceForm,
  ViewEmpCount,
  Pending,
  TotalEmp,
  Approved,
  Rejected,
  inlineDisplay,
}) => {
  const navigate = useNavigate();

  function handleClick(event, path) {
    event.preventDefault();
    navigate(path);
  }

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      href="#"
      color="inherit"
      onClick={(e) => handleClick(e, "/dashboard")}
      sx={{ fontSize: "14px", fontWeight: 600 }}
    >
      Dashboard
    </Link>,
    topViewNavData.backPath ? (
      <Link
        underline="hover"
        key="2"
        color="inherit"
        href="#"
        onClick={(e) => handleClick(e, topViewNavData.backPathRoute)}
        sx={{ fontSize: "14px" }}
      >
        {topViewNavData.backPath}
      </Link>
    ) : (
      ""
    ),
    <Typography key="3" color="text.primary" sx={{ fontSize: "14px" }}>
      {topViewNavData.title}
    </Typography>,
    topViewNavData.CompanyName ? (
      <Typography key="3" color="text.primary" sx={{ fontSize: "14px" }}>
        {topViewNavData.CompanyName}
      </Typography>
    ) : (
      ""
    ),
  ];

  return (
    <>
      <Box
        className="res_top"
        sx={{
          display: inlineDisplay ? "inline-flex" : "flex",
          // marginTop: "20px",
          marginLeft: `${
            window.location.pathname === "/outdoorduties" ? "0px" : 0
          }`,
        }}
      >
        <IconButton
          sx={{ margin: "0 0.6rem 0 0rem", color: "#2DB0B5" }}
          onClick={() => navigate(topViewNavData.backPathRoute)}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box className="pgnsn" display={"flex"} alignItems="center">
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#2A3478",
              margin: "0 0.6rem 0 0rem",
            }}
          >
            {topViewNavData.title}
          </Typography>
          <Typography className="breadcNamv" variant="h6">
            <Breadcrumbs aria-label="breadcrumb">{breadcrumbs}</Breadcrumbs>
          </Typography>
        </Box>
      </Box>
      {statusBtn && (
        <Box sx={{ position: "absolute", left: "40%" }}>
          <Stack spacing={2} direction="row">
            <CustomButton
              name={"Approve"}
              background={"rgb(50 164 114)"}
              onClick={() => ApproveHandler("APPROVED")}
            />
            <CustomButton
              name={"Reject"}
              background={"rgb(233 75 97)"}
              onClick={() => ApproveHandler("REJECTED")}
            />
          </Stack>
        </Box>
      )}

      {clientSatatusBtn && (
        <Box>
          <Stack spacing={2} direction="row">
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={() => openDyanamiceForm("companydetails")}
                style={{
                  cursor: "pointer",
                  padding: "8px",
                }}
              >
                Expense Approver
              </div>
            </div>
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={() => openDyanamiceForm("MettingDetails")}
                style={{
                  cursor: "pointer",
                  padding: "8px",
                }}
              >
                Meeting Dynamic Form
              </div>
            </div>
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={() => openDyanamiceForm("clentsDetails")}
                style={{
                  cursor: "pointer",
                  padding: "8px",
                }}
              >
                Client Dynamic Form
              </div>
            </div>
          </Stack>
        </Box>
      )}
      {ViewEmpCount && (
        <Box>
          <Stack spacing={2} direction="row">
            {/* <div
              className="fieldBox"
              style={{
                backgroundColor: "rgb(26, 117, 255)",
              }}
            >
              <span>TotalEmp </span>
              <span className="count"> {TotalEmp}</span>
            </div>
            <div
              className="fieldBox"
              style={{
                backgroundColor: "green",
              }}
            >
              <span>Start Time </span>
              <span className="count"> {Approved}</span>
            </div>
            <div
              className="fieldBox"
              style={{
                backgroundColor: "rgb(233 75 97)",
              }}
            >
              <span>End Time </span>
              <span className="count"> {Rejected}</span>
            </div>
          

            <div
              className="fieldBox"
              style={{
                backgroundColor: "#a9a92f",
              }}
            >
              <span>Stop Location </span>
              <span className="count"> {Pending}</span>
            </div> */}
          </Stack>
        </Box>
      )}
    </>
  );
};

export default TopViewNav;
